import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

// `useQuery` sonucunu `= []` ile varsayılanlamak her render'da YENİ bir dizi üretiyor: sorgu henüz
// dönmediyse ya da hata verdiyse `data` undefined kalıyor ve varsayılan tekrar tekrar
// değerlendiriliyor. Bu referans bir useMemo zincirine girip oradan useEffect + setState'e
// ulaştığında sonsuz render döngüsü oluyor (şube kategori sırası sayfasında olan buydu).
// Paylaşılan tek bir referans zinciri sabitliyor.
export const EMPTY_LIST = Object.freeze([]);
